import { Row, Col } from 'react-bootstrap'
import { LocationIcon, PhoneIcon, EmailIcon } from './Icons'
import { useObfuscatedContact } from './useObfuscatedContact'

const Footer = ({projectPage}) => {
    const { phone, email1, email2, address } = useObfuscatedContact()
    return (
        <Row className="footer mx-0">
            <Row className="p-0 mx-0">
                <Col className="p-0 col-12 col-lg-4">
                    <Row className="p-0 mx-0">
                        <div className="footerTitle">
                            Linko Labs
                        </div>
                    </Row>
                    <Row className="p-0 mx-0">
                        <div className="footerDescription">
                            <div className="footerContactItem">
                                <LocationIcon size={18} />
                                <span>
                                    {address?.company}<br/>
                                    {address?.street}<br/>
                                    {address?.city}<br/>
                                    {address?.country}
                                </span>
                            </div>
                            <div className="footerContactItem">
                                <PhoneIcon size={18} />
                                <span>{phone}</span>
                            </div>
                            <div className="footerContactItem">
                                <EmailIcon size={18} />
                                <span>
                                    {email1}<br/>
                                    {email2}
                                </span>
                            </div>
                        </div>
                    </Row>
                </Col>
                <Col className="p-0 col-6 col-lg-3">
                    <div className="footerSubtitle">
                        Navigation
                    </div>
                    
                    {projectPage ? ( 
                        <>
                            <div className="footerMenuElement">
                                <a href="/" className="footerLink">Home</a>
                            </div>
                            <div className="footerMenuElement">
                                <a href="/#services" className="footerLink">Services</a>
                            </div>
                            <div className="footerMenuElement">
                                <a href="/#portfolio" className="footerLink">Portfolio</a>
                            </div>
                            <div className="footerMenuElement">
                                <a href="/#about" className="footerLink">About</a>
                            </div>
                        </>
                    ) : ( 
                        <>
                            <div className="footerMenuElement">
                                <a href="#top" className="footerLink">Home</a>
                            </div>
                            <div className="footerMenuElement">
                                <a href="#services" className="footerLink">Services</a>
                            </div>
                            <div className="footerMenuElement">
                                <a href="#portfolio" className="footerLink">Portfolio</a>
                            </div>
                            <div className="footerMenuElement">
                                <a href="#about" className="footerLink">About</a>
                            </div>
                        </>
                    )}
                </Col>
                <Col className="p-0 col-6 col-lg-3">
                    <div className="footerSubtitle">
                        Legal
                    </div>
                    <div className="footerMenuElement">
                        <a href="/privacy-policy" className="footerLink">Privacy Policy</a>
                    </div>
                    <div className="footerMenuElement">
                        <a href="/terms-of-service" className="footerLink">Terms of Service</a>
                    </div>
                    <div className="footerMenuElement">
                        <a href={email1 ? `mailto:${email1}` : '#'} id="ex" className="footerLink">Contact Us</a>
                    </div>
                </Col>
            </Row>
            <Row className="p-0 mx-0 footerBottom">
                <Col className="col-12 col-lg-6">
                    <div className="footerCopyright">
                        &copy; 2026 Linko Labs LLC. All rights reserved.
                    </div>
                </Col>
                <Col className="col-12 col-lg-6 text-lg-end">
                    <div className="footerCopyright">
                        Software Development & AI Integration Services
                    </div>
                </Col>
            </Row>
        </Row>
    );
}
export default Footer